<template>
  <div class="mdl-grid">
    <div class="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"></div>
    <header class="cover mdl-cell mdl-cell--8-col">
      <div class="card-cover mdl-card mdl-shadow--2dp">
        <div :class="['mdl-card__title',
                     promedio ? (
                       promedio >= tree.area.aceptable
                          ? 'bg-green'
                          : ( promedio > tree.area.inaceptable
                            ? 'bg-yellow'
                            : 'bg-red' )
                      ) : 'bg-grey'
                    ]">
          <h2 class="mdl-card__title-text">
            {{ promedio ? promedio : 'N / A' }}<br>
            <span>{{ tree.area.nombre }}</span>
            <p></p>
          </h2>
        </div>
      </div>
    </header>
    <div class="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"></div>
    <div class="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"></div>
    <main class="accordions mdl-cell mdl-cell--8-col">
      <mdl-accordion v-for="(d, i) in data"
        :tree="tree"
        :data="d"
        :index="i"
        :key="i"
        @trigger="calcularPromedio()"></mdl-accordion>
      <!-- <mdl-accordion title="Pisos"></mdl-accordion> -->
    </main>
  </div>
</template>

<script>
import Accordion from './Accordion'

export default {
  props: ['tree', 'data', 'index'],
  components: {
    'mdl-accordion': Accordion
  },
  data () {
    return {
      promedio: 0,
      actionbar: {
        show: true,
        buttons: [
          {
            text: 'Regresar',
            onclick: () => {
              this.$emit('goBack', -1)
            }
          },
          {
            text: 'Guardar',
            onclick: () => {
              const textfields = document.querySelectorAll('.incidence--opened .mdl-textfield__input'),
                    photos = document.querySelectorAll('.incidence--opened .photos')

              for (let i in textfields) {
                if (textfields[i].value === '') {
                  return this.$toast.show('Favor de escribir tus observaciones en cada incidencia.')
                }
              }

              for (let i in photos) {
                if (photos[i].childElementCount === 0) {
                  return this.$toast.show('Favor de asignar mínimo una fotografía en cada incidencia.')
                }
              }

              let rubros = this.data,
                  promises = []

              rubros.forEach(rubro => {
                rubro.puntos = 0
                rubro.incidencias = 0

                rubro.especificaciones.forEach(especificacion => {
                  rubro.puntos += especificacion.selected.valor
                  rubro.incidencias += especificacion.selected.color.match(/red|yellow/) ? 1 : 0
                })

                rubro.promedio = Math.round10( (rubro.puntos / rubro.especificaciones.length), -2)
                promises.push(this.$idb.keyVal.set('rubros', undefined, rubro))
              })

              Promise.all(promises).then(() => {
                this.$emit('activeAudit', true)
                this.$emit('goBack', -1)
              }, () => {
                this.$toast.show('¡Algo sucedió! Porfavor vuelve a intentar guardar.')
              })
            }
          }
        ]
      }
    }
  },
  methods: {
    calcularPromedio () {
      const rubros = this.data
      let puntos = 0,
          length = 0

      rubros.forEach(rubro => {
        length += rubro.especificaciones.length
        rubro.especificaciones.forEach(especificacion => {
          puntos += especificacion.selected.valor
        })
      })

      this.promedio = Math.round10( (puntos / length), -2)
    }
  },
  watch: {
    data () {
      this.calcularPromedio()
      this.$actionbar.init(this.actionbar)
    }
  },
  mounted () {
    this.calcularPromedio()
    this.$actionbar.init(this.actionbar)
  }
}
</script>

<style lang="css" scoped>
  .mdl-grid {
    width: 100%;
    margin: 0;
  }

  .card-cover {
    width: 100%;
    min-height: 200px;
    color: #fff !important;
    opacity: 1;
  }

  .card-cover .mdl-card__title {
    height: 200px;
    background-color: grey;
  }

  .card-cover .mdl-card__title * {
   color: #fff !important;
   opacity: 1;
  }

  .card-cover .mdl-card__title .mdl-card__title-text {
    height: 100%;
    padding: 24px;
    margin-bottom: 10px;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .card-cover .mdl-card__supporting-text {
    width: 100%;
    height: auto;
    background: #fff;
    z-index: 1;

    box-sizing: border-box;
    padding: 16px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }

  .card-cover .mdl-card__supporting-text > * {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .card-cover .mdl-card__supporting-text > *:first-child {
    margin-right: 16px;
  }

  .card-cover .mdl-card__supporting-text .minilogo {
    width: 44px;
    height: 44px;
    background-image: url(./img/profile-64.png);
    background-position: center;
    background-repeat: no-repeat;
    /* background-size: 50%; */
    border-radius: 22px;
    background-color: #F5F5F5;
  }

  .card-cover .mdl-card__supporting-text strong {
    font-weight: bold;
  }

  .card-cover .flex-grow-2 {
    flex-grow: 2;
  }
</style>


// WEBPACK FOOTER //
// Audit.vue?6f4ea11f